<template>
  <router-link
    class="app-link"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </router-link>
</template>

<script>
export default {
  name: 'AppLink',
  inheritAttrs: false,
}
</script>

<style lang="sass" scoped>
  .app-link
    text-decoration: none

    &:hover
      text-decoration: underline
</style>
